import React from "react"
import ReactDOM from "react-dom/client"

import { CollectionGrid, type Props } from "./component"

const App = class extends HTMLElement {
  root: ReactDOM.Root | null = null

  connectedCallback() {
    const props: Partial<Props> = {}

    this.querySelectorAll("script").forEach((script) => {
      try {
        const data = JSON.parse(script.innerHTML)
        const name = script.getAttribute("name")

        if (!name) return

        props[name as keyof Props] = data
      } catch (error) {
        console.error(error)
      }
    })

    // Read URL parameters for initial results sort, filters, and page
    const params = new URLSearchParams(window.location.search)
    const sort = params.get("sort") || ""
    const filters = params.get("filters") || ""
    const page = params.get("page") || ""

    if (!this.root) this.root = ReactDOM.createRoot(this)
    this.root.render(
      <CollectionGrid
        {...(props as Props)}
        sort={sort}
        filters={filters}
        page={page}
      />
    )
  }
}

customElements.define("ss-collection-grid", App)
